import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  TextInput,
  Textarea,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMOrderType } from "../../../../model/TblDMOrderType";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { useEffect } from "react";
import { sky_blue } from "../../../../const/variables";

const CreateDataView = ({ onClose }: CreateDataViewProps) => {
  const entity = {
    id: "0",
    ordertype: null,
    name: null,
    note: null,
    active: null,
    linetype: null,
    lineck: null,
    industry: null,
    createDate: null,
    createBy: null,
    lastUpdateDate: null,
    lastUpdateBy: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<TblDMOrderType>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      name: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên loại đơn hàng!";
        }
        return hasLength(
          { min: 5, max: 150 },
          "Tên phải từ 5-150 kí tự!"
        )(value as string);
      },
      ordertype: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập loại đơn hàng!";
        }
        return hasLength(
          { max: 50 },
          "Loại phải nhỏ hơn 50 kí tự!"
        )(value as string);
      },
      note: (value?: string | null) => {
        if (value) {
          return hasLength(
            { max: 250 },
            "Ghi chú phải nhỏ hơn 250 kí tự!"
          )(value as string);
        }
      },
    },
  });

  const callApiGetData = async () => {
    open();
    const callApi = await repositoryMdm.get<MessageResponse<TblDMOrderType>>(
      "/api/v1/TblDMOrderType/create"
    );
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Bạn không có quyền tạo!!!");
      modals.closeAll();
    }
  };

  const handleCreateTblDMOrderType = async (dataSubmit: TblDMOrderType) => {
    open();
    const dataApi = await repositoryMdm.post<MessageResponse<TblDMOrderType>>(
      "/api/v1/TblDMOrderType/create",
      dataSubmit
    );
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
    }
    close();
  };

  useEffect(() => {
    callApiGetData();
  }, []);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        w={{ base: "280px", md: "336px", lg: "448px" }}
        onSubmit={form.onSubmit((e: TblDMOrderType) => {
          handleCreateTblDMOrderType(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={4}>
            <TextInput
              label={"Loại đơn hàng"}
              placeholder={"Nhập Loại"}
              withAsterisk
              {...form.getInputProps("ordertype")}
            />
          </Grid.Col>
          <Grid.Col span={8}>
            <TextInput
              label={"Tên đơn hàng"}
              placeholder={"Nhập tên"}
              withAsterisk
              w={"100%"}
              {...form.getInputProps("name")}
            />
          </Grid.Col>
        </Grid>

        <Grid align="center">
          <Grid.Col span={12}>
            <Textarea
              label={"Ghi chú"}
              placeholder="Nhập ghi chú"
              w={"100%"}
              {...form.getInputProps("note")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox label={"Sử dụng"} {...form.getInputProps("active")} />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default CreateDataView;

type CreateDataViewProps = {
  onClose: any;
};
